export const tData = {
  sq: {
    appName: "Bauheld",

    navSubtitle: "Finance Suite",
    searchPlaceholder: "Kërko...",
    dashboard: "Ballina",
    projects: "Projektet",
    offers: "Ofertat",
    kalkulation: "Kalkulimi",
    calendar: "Kalendari",
    timesheets: "Orët e punës",
    projectProfit: "Fitimi i projekteve",
    income: "Hyrje",
    expenses: "Shpenzime",
    payments: "Pagesa",
    materials: "Materiale",
    workers: "Punëtorë",
    reports: "Raporte",
    settings: "Cilësimet",
    logout: "Dil",
    invoiceOverdue: "Me vonesë",
    invoiceStatusAuto: "Status automatik",
    paymentHistory: "Historia e pagesave",
    records: "regjistrime",
    materialsHistoryTitle: "Historia e materialeve",

    noOverdueInvoices: "Nuk ka fatura të vonuara për momentin",
    loadingOverdueWarnings: "Duke ngarkuar paralajmërimet për vonesa...",
    attention: "Vëmendje",
    overdueInvoicesLabel: "fatura të vonuara",
    openTotal: "Totali i hapur",
    dueLabel: "Afati",
    incomeHistoryTitle: "Historia e hyrjeve",

    language: "Gjuha",
    albanian: "Shqip",
    german: "Gjermanisht",
    switchLanguage: "Ndërro gjuhën",

    loading: "Duke ngarkuar...",
    save: "Ruaj",
    cancel: "Anulo",
    close: "Mbyll",
    edit: "Ndrysho",
    delete: "Fshij",
    add: "Shto",
    update: "Përditëso",
    create: "Krijo",
    search: "Kërko",
    filter: "Filtro",
    clear: "Pastro",
    actions: "Veprime",
    status: "Statusi",
    date: "Data",
    description: "Përshkrimi",
    amount: "Shuma",
    method: "Metoda",
    total: "Totali",
    notes: "Shënime",
    noDescription: "Pa përshkrim",
    noData: "Nuk ka të dhëna",
    category: "Kategoria",
    phone: "Telefoni",
    supplier: "Furnitori",
    quantity: "Sasia",
    unit: "Njësia",
    day: "ditë",
    role: "Roli",
    startDate: "Data e fillimit",

    prev: "Para",
    next: "Pas",
    page: "Faqja",
    of: "nga",

    dashboardActivityTitle: "Aktiviteti i fundit",
    dashboardActivitySubtitle: "Veprimet më të fundit financiare nga faturat, të hyrat dhe shpenzimet.",
    dashboardTitle: "Ballina",
    dashboardSubtitle: "Përmbledhje e hyrjeve, shpenzimeve dhe aktivitetit të fundit.",
    totalIncome: "Totali i hyrjeve",
    totalExpenses: "Totali i shpenzimeve",
    balance: "Bilanci",
    transactions: "Transaksione",
    registeredIncome: "Të ardhurat e regjistruara",
    registeredExpenses: "Shpenzimet e regjistruara",
    diffIncomeExpenses: "Dallimi mes hyrjeve dhe shpenzimeve",
    totalRecords: "Numri total i regjistrimeve",
    recentActivity: "Aktiviteti i fundit",
    recentActivitySubtitle: "Hyrjet dhe shpenzimet më të fundit në sistem.",
    monthlySummary: "Përmbledhje mujore",
    monthlySummarySubtitle: "Performanca financiare e muajit aktual.",
    quickOverview: "Gjendja e shpejtë",
    quickOverviewSubtitle: "Një pamje e shpejtë e financave.",
    thisMonthIncome: "Hyrje këtë muaj",
    thisMonthExpenses: "Shpenzime këtë muaj",
    monthResult: "Rezultati i muajit",
    monthResultSubtitle: "Bilanci i muajit aktual bazuar në të dhënat e regjistruara.",
    noActivity: "Ende nuk ka aktivitet",
    noActivitySubtitle: "Shto hyrje ose shpenzime dhe do të shfaqen këtu.",
    incomeLabel: "Hyrje",
    expenseLabel: "Shpenzim",
    items: "artikuj",

    incomeTitle: "Hyrje",
    incomeSubtitle: "Regjistro të ardhurat dhe mbaj historikun financiar të pastër.",
    addIncomeTitle: "Shto hyrje",
    saveIncome: "Ruaj hyrjen",
    savingIncome: "Duke ruajtur...",
    incomeHistory: "Historia e hyrjeve",
    incomeHistorySubtitle: "Shiko hyrjet e fundit dhe mënyrën e pagesës.",
    noIncomeYet: "Ende nuk ka hyrje",
    noIncomeYetSubtitle: "Regjistro hyrjen e parë dhe do të shfaqet këtu.",
    totalIncomeCard: "Totali i hyrjeve",
    totalIncomeCardSubtitle: "Të gjitha hyrjet e regjistruara",
    thisMonth: "Ky muaj",
    thisMonthSubtitle: "Performanca mujore e hyrjeve",
    cashPayments: "Pagesa Cash",
    cashPaymentsSubtitle: "Numri i hyrjeve me para në dorë",
    amountPlaceholder: "P.sh. 250.00",
    descriptionPlaceholder: "P.sh. Pagesë nga klienti",
    cash: "Cash",
    bank: "Bankë",
    card: "Kartelë",
    saveErrorIncome: "Gabim gjatë ruajtjes së hyrjes.",

    expensesTitle: "Shpenzime",
    expensesSubtitle: "Regjistro shpenzimet dhe mbaj kostot nën kontroll.",
    addExpenseTitle: "Shto shpenzim",
    addExpenseSubtitle: "Regjistro kosto të reja dhe kategorizoji sipas metodës dhe kategorisë.",
    saveExpense: "Ruaj shpenzimin",
    savingExpense: "Duke ruajtur...",
    expenseHistory: "Historia e shpenzimeve",
    expenseHistorySubtitle: "Shiko shpenzimet e fundit me metodë dhe kategori.",
    noExpensesYet: "Ende nuk ka shpenzime",
    noExpensesYetSubtitle: "Regjistro shpenzimin e parë dhe do të shfaqet këtu.",
    totalExpensesCard: "Totali i shpenzimeve",
    totalExpensesCardSubtitle: "Të gjitha shpenzimet e regjistruara",
    cashExpenses: "Shpenzime Cash",
    cashExpensesCard: "Shpenzime Cash",
    cashExpensesSubtitle: "Numri i shpenzimeve me para në dorë",
    topExpenseCategory: "Kategoria kryesore",
    topCategory: "Kategoria kryesore",
    topExpenseCategorySubtitle: "Kategoria me koston më të lartë",
    topCategorySubtitle: "Kategoria me koston më të lartë",
    expenseDescriptionPlaceholder: "P.sh. Blerje materiali",
    expenseCategoryMaterial: "Material",
    expenseCategoryTransport: "Transport",
    expenseCategorySalary: "Pagë",
    expenseCategoryTools: "Vegla",
    expenseCategoryOther: "Tjetër",
    saveErrorExpense: "Gabim gjatë ruajtjes së shpenzimit.",

    invoiceReminderTools: "Mjetet e rikujtesës",
    invoiceReminderSubtitle: "Dërgo rikujtesë për pagesën me copy, WhatsApp ose email.",
    invoiceCopyReminder: "Kopjo rikujtesën",
    invoicePaymentStatusTitle: "Statusi i pagesës",
    invoicePaidPartial: "Pjesërisht",
    invoicePaidFull: "E paguar plotësisht",
    invoiceDocumentPreview: "Parapamja e faturës",
    invoiceDocumentPreviewSubtitle: "Parapamja e dokumentit të tregon rezultatin përfundimtar para printimit",
    invoicePreviewTitle: "Parapamja e faturës",
    invoicePreviewSubtitle: "Parapamja e dokumentit të tregon rezultatin përfundimtar para printimit",
    

    paymentsTitle: "Pagesa",
    paymentsSubtitle: "Menaxho pagesat, statuset dhe afatet në një vend të vetëm.",
    addPaymentTitle: "Shto pagesë",
    addPaymentSubtitle: "Regjistro pagesa me përfitues, metodë dhe status.",
    savePayment: "Ruaj pagesën",
    savingPayment: "Duke ruajtur...",
    paymentHistorySubtitle: "Shiko pagesat e fundit me status dhe kategori.",
    noPaymentsYet: "Ende nuk ka pagesa",
    noPaymentsYetSubtitle: "Regjistro pagesën e parë dhe do të shfaqet këtu.",
    totalPaymentsCard: "Totali i pagesave",
    totalPaymentsCardSubtitle: "Të gjitha pagesat e regjistruara",
    pendingPayments: "Pagesa në pritje",
    pendingPaymentsCard: "Pagesa në pritje",
    pendingPaymentsCardSubtitle: "Pagesat që ende nuk janë përfunduar",
    paidPayments: "Pagesa të paguara",
    paidPaymentsSubtitle: "Numri i regjistrimeve të paguara",
    thisMonthPayments: "Pagesa këtë muaj",
    thisMonthPaymentsSubtitle: "Performanca mujore e pagesave",
    paymentTo: "Përfituesi",
    paymentToPlaceholder: "P.sh. Furnitor / Punëtor",
    paymentDescriptionPlaceholder: "P.sh. Pagesë mujore",
    paymentStatusPending: "Në pritje",
    paymentStatusPaid: "Paguar",
    paymentCategorySupplier: "Furnitor",
    paymentCategoryWorker: "Punëtor",
    paymentCategoryRent: "Qira",
    paymentCategoryService: "Shërbim",
    paymentCategoryOther: "Tjetër",
    saveErrorPayment: "Gabim gjatë ruajtjes së pagesës.",

    backupRestoreTitle: "Backup & Restore",
    backupRestoreSubtitle: "Ruajtje lokale, rikthim dhe reset selektiv i databazës.",
    backupDownloadTitle: "Shkarko backup",
    backupDownloadText: "Krijon backup të plotë lokal për PC / arkivë / migrim.",
    backupDownloadBtn: "Shkarko backup",
    backupImportTitle: "Ngarko backup",
    backupImportText: "Zgjidh një file JSON ekzistues dhe shfaq paraprakisht çfarë përmban.",
    backupChooseFile: "Zgjidh file",
    backupSelectedFile: "File i zgjedhur",
    backupPreview: "Paraqitje",
    backupNoFile: "Ende s'është zgjedhur file.",
    backupCollections: "Koleksione",
    backupEntries: "Hyrje",
    backupReplaceTitle: "Restore Replace",
    backupReplaceText: "Zëvendëson të dhënat ekzistuese me ato të backup-it të ngarkuar.",
    backupReplaceBtn: "Rikthe komplet",
    backupMergeTitle: "Merge Import",
    backupMergeText: "Shton të dhënat e backup-it mbi databazën ekzistuese.",
    backupMergeBtn: "Importo sipër",
    backupLoaded: "Backup file u ngarkua me sukses.",
    backupDownloadOk: "Backup u shkarkua me sukses.",
    backupMergeOk: "Backup u importua me sukses.",
    backupReplaceOk: "Backup u rikthye me sukses.",
    backupParseFail: "Nuk u lexua backup file.",
    backupNoPayload: "Së pari zgjidh një backup file.",
    backupReplaceWarning: "Kujdes: Replace i mbishkruan të dhënat aktuale.",

    selectiveResetTitle: "Reset selektiv",
    selectiveResetText: "Zgjidh kategoritë që dëshiron t’i fshish komplet nga databaza.",
    selectiveResetBtn: "Fshij kategoritë e zgjedhura",
    selectiveResetOk: "Kategoritë e zgjedhura u fshinë me sukses.",
    selectiveResetNone: "Zgjidh të paktën një kategori.",
    selectiveResetWarning: "A je i sigurt që dëshiron t’i fshish këto kategori?",
    selectAll: "Zgjidh të gjitha",
    clearSelection: "Pastro zgjedhjen",
    deleting: "Duke fshirë...",

    backupIncome: "Income",
    backupExpenses: "Expenses",
    backupPayments: "Payments",
    backupMaterials: "Materials",
    backupWorkers: "Workers",
    backupInvoiceClients: "Invoice Clients",
    backupInvoices: "Invoices",
    backupMonthlyStats: "Monthly Stats",
    backupCompanySettings: "Company Settings",

    materialsTitle: "Materiale",
    materialsSubtitle: "Menaxho materialet, stokun, furnitorët dhe vlerën e magazinës në një vend.",
    totalMaterialsValue: "Vlera totale e stokut",
    totalMaterialsValueSubtitle: "Vlera e përgjithshme e të gjitha materialeve",
    inStockMaterials: "Në stok",
    inStockMaterialsSubtitle: "Materialet me stok normal",
    lowStockMaterials: "Stok i ulët",
    lowStockMaterialsSubtitle: "Materialet që duhen porositur së shpejti",
    orderedMaterials: "Porositur",
    orderedMaterialsSubtitle: "Materialet që janë aktualisht të porositura",
    addMaterialTitle: "Shto material",
    addMaterialSubtitle: "Regjistro materiale të reja me sasi, çmim dhe furnitor.",
    materialName: "Emri i materialit",
    materialNamePlaceholder: "P.sh. Çimento",
    supplierPlaceholder: "P.sh. Partneri i ndërtimit",
    pricePerUnit: "Çmimi për njësi",
    saveMaterial: "Ruaj materialin",
    savingMaterial: "Duke ruajtur...",
    saveErrorMaterial: "Gabim gjatë ruajtjes së materialit.",
    materialsHistory: "Pasqyra e materialeve",
    materialsHistorySubtitle: "Shiko stokun, furnitorët dhe vlerën e materialeve.",
    noMaterialsYet: "Ende nuk ka materiale",
    noMaterialsYetSubtitle: "Regjistro materialin e parë dhe do të shfaqet këtu.",
    confirmDeleteMaterial: "A dëshiron ta fshish këtë material?",
    materialUnitPieces: "copë",
    materialUnitKg: "kg",
    materialUnitM2: "m²",
    materialUnitM3: "m³",
    materialUnitBox: "kuti",
    materialStatusInStock: "Në stok",
    materialStatusLowStock: "Stok i ulët",
    materialStatusOrdered: "Porositur",

    workersTitle: "Punëtorë",
    workersSubtitle: "Menaxho punëtorët, rolet, pagesën ditore dhe statusin e punës në një vend.",
    totalWorkers: "Totali i punëtorëve",
    totalWorkersSubtitle: "Numri total i punëtorëve të regjistruar",
    activeWorkers: "Aktivë",
    activeWorkersSubtitle: "Punëtorët që janë aktualisht aktivë",
    vacationWorkers: "Në pushim",
    vacationWorkersSubtitle: "Punëtorët në pushim ose përkohësisht jo prezent",
    inactiveWorkers: "Punëtorë jo aktivë",
    dailyPayrollEstimate: "Kosto ditore e vlerësuar",
    dailyPayrollEstimateSubtitle: "Shuma e të gjitha pagesave ditore",
    addWorkerTitle: "Shto punëtor",
    addWorkerSubtitle: "Regjistro punëtorë të rinj me rol, pagesë ditore dhe status.",
    workerName: "Emri i punëtorit",
    workerNamePlaceholder: "P.sh. Arben Krasniqi",
    dailyRate: "Pagesa ditore",
    saveWorker: "Ruaj punëtorin",
    savingWorker: "Duke ruajtur...",
    saveErrorWorker: "Gabim gjatë ruajtjes së punëtorit.",
    workersHistory: "Pasqyra e punëtorëve",
    workersHistorySubtitle: "Shiko rolet, statusin dhe pagesën ditore të punëtorëve.",
    noWorkersYet: "Ende nuk ka punëtorë",
    noWorkersYetSubtitle: "Regjistro punëtorin e parë dhe do të shfaqet këtu.",
    confirmDeleteWorker: "A dëshiron ta fshish këtë punëtor?",
    workerRoleWorker: "Punëtor",
    workerRoleManager: "Menaxher",
    workerRoleDriver: "Shofer",
    workerRoleElectrician: "Elektricist",
    workerRoleMason: "Murator",
    workerStatusActive: "Aktiv",
    workerStatusVacation: "Pushim",
    workerStatusInactive: "Jo aktiv",

    reportsTitle: "Raporte",
    reportsSubtitle: "Një pasqyrë e qartë e financave, magazinës dhe fuqisë punëtore.",
    reportIncomeSummary: "Hyrje",
    reportIncomeSummarySubtitle: "Të gjitha hyrjet e regjistruara",
    reportExpenseSummary: "Shpenzime",
    reportExpenseSummarySubtitle: "Të gjitha shpenzimet e regjistruara",
    reportPaymentSummary: "Pagesa",
    reportPaymentSummarySubtitle: "Të gjitha pagesat e regjistruara",
    reportNetBalance: "Bilanci neto",
    reportNetBalanceSubtitle: "Hyrjet minus shpenzimet dhe pagesat",
    monthlyOverviewTitle: "Përmbledhje mujore",
    monthlyOverviewSubtitle: "Performanca për muajin aktual",
    reportMonthResultSubtitle: "Rezultati mujor pas shpenzimeve dhe pagesave",
    reportAssetsTitle: "Stoku & ekipi",
    reportAssetsSubtitle: "Tregues kyç për magazinën dhe punëtorët",
    reportExpenseBreakdown: "Shpenzime sipas kategorisë",
    reportExpenseBreakdownSubtitle: "Zonat kryesore të kostove të biznesit",
    reportPaymentBreakdown: "Pagesa sipas kategorisë",
    reportPaymentBreakdownSubtitle: "Shpërndarja e pagesave të regjistruara",
    reportMaterialStatus: "Statusi i materialeve",
    reportMaterialStatusSubtitle: "Pasqyrë mbi gjendjen e stokut",
    reportWorkerStatus: "Statusi i punëtorëve",
    reportWorkerStatusSubtitle: "Pasqyrë mbi disponueshmërinë e ekipit",

    invoiceTitle: "Faturë",
    invoiceSubtitle: "Krijo fatura profesionale dhe ruaji në sistem.",
    invoiceCreateTitle: "Krijo faturë",
    invoiceCreateSubtitle: "Plotëso të dhënat e klientit, artikujt dhe pagesën.",
    invoiceHistoryTitle: "Historia e faturave",
    invoiceHistorySubtitle: "Faturat e ruajtura së fundi.",
    invoiceCustomer: "Klienti",
    invoiceCustomerEmail: "Email",
    invoiceCustomerPhone: "Telefoni",
    invoiceCustomerAddress: "Adresa",
    invoiceNumber: "Numri i faturës",
    invoiceDate: "Data e faturës",
    invoiceDueDate: "Afati i pagesës",
    invoiceItems: "Artikujt",
    invoiceUnitPrice: "Çmimi / njësi",
    invoiceLineTotal: "Totali",
    invoiceAddItem: "Shto artikull",
    invoiceSave: "Ruaj faturën",
    invoiceSaving: "Duke ruajtur...",
    invoicePrint: "Printo / PDF",
    invoiceRefresh: "Rifresko",
    invoiceNoInvoices: "Ende nuk ka fatura",
    invoiceNoInvoicesSubtitle: "Krijo faturën e parë dhe do të shfaqet këtu.",
    invoiceSaveError: "Gabim gjatë ruajtjes së faturës.",
    invoiceCompanySection: "Të dhënat e firmës",
    invoicePaymentInfo: "Informacioni i pagesës",

    settingsTitle: "Cilësimet",
    settingsSubtitle: "Menaxho të dhënat e firmës, logon, ngjyrat dhe informacionet e faturimit në një vend.",
    companyProfileTitle: "Profili i firmës",
    companyProfileSubtitle: "Të dhënat kryesore të kompanisë tënde.",
    brandingTitle: "Branding",
    brandingSubtitle: "Përshtat logon, ngjyrat dhe identitetin vizual.",
    billingSettingsTitle: "Faturimi & banka",
    billingSettingsSubtitle: "Informacione për fatura dhe pagesa.",
    previewCardTitle: "Parapamja",
    previewCardSubtitle: "Kështu mund të duket karta e firmës në sistem.",
    companyNameLabel: "Emri i firmës",
    ownerNameLabel: "Pronari / Personi përgjegjës",
    taxNumberLabel: "Numri fiskal",
    businessNumberLabel: "Numri i biznesit",
    emailLabel: "Email",
    websiteLabel: "Uebfaqja",
    addressLabel: "Adresa",
    cityLabel: "Qyteti",
    countryLabel: "Shteti",
    postalCodeLabel: "Kodi postar",
    logoUrlLabel: "Linku i logos",
    primaryColorLabel: "Ngjyra primare",
    secondaryColorLabel: "Ngjyra sekondare",
    invoicePrefixLabel: "Prefiksi i faturës",
    currencyLabel: "Valuta",
    bankNameLabel: "Emri i bankës",
    saveSettings: "Ruaj cilësimet",
    savingSettings: "Duke ruajtur...",
    loadErrorSettings: "Cilësimet nuk u ngarkuan dot.",
    saveErrorSettings: "Gabim gjatë ruajtjes së cilësimeve.",
    saveSuccessSettings: "Cilësimet u ruajtën me sukses.",
    previewEmptyCompany: "Emri i firmës do të shfaqet këtu",
    logoHint: "Përdor një link direkt të figurës për logon e firmës.",
    brandHint: "Këto ngjyra mund t’i përdorësh më vonë edhe për PDF, fatura dhe karta.",
    profileHint: "Këto të dhëna mund të përdoren më vonë në raporte dhe fatura.",
    lastSavedLabel: "Ruajtur",
    settingsQuickInfo: "Këto të dhëna ruhen te settings/company në Firestore.",

    dashboardOptimizedSubtitle: "Panel i Optimizuar",
    dashboardInvoiced: "Faturuar",
    dashboardPaidInInvoices: "Paguar në fatura",
    dashboardOpenInvoices: "Fatura të hapura",
    dashboardProfit: "Rezultati",
    dashboardLastInvoices: "Faturat e fundit",
    dashboardLastIncome: "Hyrjet e fundit",
    dashboardLastExpenses: "Shpenzimet e fundit",
    dashboardCurrentMonthStats: "Statistikat e muajit aktual",
    dashboardCurrentMonthStatsSubtitle: "Një pamje e shpejtë e treguesve financiarë më të rëndësishëm të këtij muaji.",
    dashboardChartsTitle: "Grafikët & trendet",
    dashboardChartsSubtitle: "Pasqyrë mujore vizuale e ndërtuar vetëm nga stats docs.",
    dashboardOverdueTitle: "Faturat overdue",
    dashboardOverdueSubtitle: "Paralajmërim i menjëhershëm për faturat që kërkojnë ndjekje.",

    invoicePrintHint: "Printo faturën ose kopjo emrin e skedarit PDF",
    invoicePdfToolsTitle: "PDF & Printim",
    invoiceCopyPdfName: "Kopjo emrin e PDF-së",
    invoiceSuiteBadge: "BauHeld Faturat",
    invoiceClientsStat: "Klientë",
    invoiceInvoicesStat: "Fatura",
    invoiceTotalAmount: "Totali faturës",
    invoiceUnpaid: "E papaguar",

    dashboardCashFlowTitle: "Fluksi i Parave",
    dashboardCashFlowSubtitle: "Ndarja mujore e hyrjeve, shpenzimeve dhe pagesave.",
    dashboardInvoicedVsResultTitle: "Faturat vs Rezultati",
    dashboardInvoicedVsResultSubtitle: "Krahasim mujor mes faturimit dhe rezultatit.",
    dashboardIncomeShort: "Të Ardhura",
    dashboardExpensesShort: "Shpenzime",
    dashboardPaymentsShort: "Pagesa",
    dashboardResultShort: "Rezultati",
    dashboardNoChartData: "Nuk ka ende të dhëna grafiku për këtë periudhë.",
    dashboardOnlyRealData: "Vetëm të dhëna reale nga Firebase",

    initializeFirestore: "Inicializo Firestore",
    setupSubtitle: "Konfiguro databazën fillestare dhe parametrat bazë."
  },

  de: {
    appName: "Bauheld",

    navSubtitle: "Finanzübersicht",
    searchPlaceholder: "Suchen...",
    dashboard: "Startseite",
    projects: "Projekte",
    offers: "Angebote",
    kalkulation: "Kalkulation",
    calendar: "Kalender",
    timesheets: "Arbeitszeiten",
    projectProfit: "Projektgewinn",
    income: "Einnahmen",
    expenses: "Ausgaben",
    payments: "Zahlungen",
    materials: "Materialien",
    workers: "Mitarbeiter",
    reports: "Berichte",
    settings: "Einstellungen",
    logout: "Abmelden",

    noOverdueInvoices: "Keine überfälligen Rechnungen im Moment",
    loadingOverdueWarnings: "Überfällige Warnungen werden geladen...",
    attention: "Achtung",
    overdueInvoicesLabel: "überfällige Rechnungen",
    openTotal: "Offener Gesamtbetrag",
    dueLabel: "Fällig",

    language: "Sprache",
    albanian: "Albanisch",
    german: "Deutsch",
    switchLanguage: "Sprache wechseln",

    loading: "Wird geladen...",
    save: "Speichern",
    cancel: "Abbrechen",
    close: "Schließen",
    edit: "Bearbeiten",
    delete: "Löschen",
    add: "Hinzufügen",
    update: "Aktualisieren",
    create: "Erstellen",
    search: "Suchen",
    filter: "Filtern",
    clear: "Zurücksetzen",
    actions: "Aktionen",
    status: "Status",
    date: "Datum",
    description: "Beschreibung",
    amount: "Betrag",
    method: "Zahlungsmethode",
    total: "Gesamt",
    notes: "Notizen",
    noDescription: "Keine Beschreibung",
    noData: "Keine Daten vorhanden",
    records: "Einträge",
    category: "Kategorie",
    phone: "Telefon",
    supplier: "Lieferant",
    quantity: "Menge",
    unit: "Einheit",
    day: "Tag",
    role: "Branche",
    startDate: "Startdatum",

    prev: "Zurück",
    next: "Weiter",
    page: "Seite",
    of: "von",

    dashboardActivityTitle: "Letzte Aktivitäten",
    dashboardActivitySubtitle: "Neueste Finanzaktionen aus Rechnungen, Einnahmen und Ausgaben.",
    dashboardTitle: "Startseite",
    dashboardSubtitle: "Übersicht über Einnahmen, Ausgaben und die letzten Aktivitäten.",
    totalIncome: "Gesamteinnahmen",
    totalExpenses: "Gesamtausgaben",
    balance: "Saldo",
    transactions: "Transaktionen",
    registeredIncome: "Erfasste Einnahmen",
    registeredExpenses: "Erfasste Ausgaben",
    diffIncomeExpenses: "Differenz zwischen Einnahmen und Ausgaben",
    totalRecords: "Gesamtanzahl der Einträge",
    recentActivity: "Letzte Aktivitäten",
    recentActivitySubtitle: "Die neuesten Einnahmen und Ausgaben im System.",
    monthlySummary: "Monatsübersicht",
    monthlySummarySubtitle: "Finanzielle Leistung des aktuellen Monats.",
    quickOverview: "Schnellübersicht",
    quickOverviewSubtitle: "Ein schneller Überblick über die Finanzen.",
    thisMonthIncome: "Einnahmen diesen Monat",
    thisMonthExpenses: "Ausgaben diesen Monat",
    monthResult: "Monatsergebnis",
    monthResultSubtitle: "Saldo des aktuellen Monats basierend auf den erfassten Daten.",
    noActivity: "Noch keine Aktivitäten vorhanden",
    noActivitySubtitle: "Erfasse Einnahmen oder Ausgaben und sie werden hier angezeigt.",
    incomeLabel: "Einnahme",
    expenseLabel: "Ausgabe",
    items: "Einträge",

    incomeTitle: "Einnahmen",
    incomeSubtitle: "Erfasse Einnahmen und halte die Finanzhistorie sauber und übersichtlich.",
    addIncomeTitle: "Einnahme hinzufügen",
    saveIncome: "Einnahme speichern",
    savingIncome: "Wird gespeichert...",
    incomeHistory: "Einnahmenverlauf",
    incomeHistorySubtitle: "Sieh dir die letzten Einnahmen und die Zahlungsart an.",
    noIncomeYet: "Noch keine Einnahmen vorhanden",
    noIncomeYetSubtitle: "Erfasse die erste Einnahme und sie wird hier angezeigt.",
    totalIncomeCard: "Gesamteinnahmen",
    totalIncomeCardSubtitle: "Alle erfassten Einnahmen",
    thisMonth: "Dieser Monat",
    thisMonthSubtitle: "Monatliche Entwicklung der Einnahmen",
    cashPayments: "Barzahlungen",
    cashPaymentsSubtitle: "Anzahl der Einnahmen in bar",
    amountPlaceholder: "Z. B. 250.00",
    descriptionPlaceholder: "Z. B. Zahlung vom Kunden",
    cash: "Bar",
    bank: "Bank",
    card: "Karte",
    saveErrorIncome: "Fehler beim Speichern der Einnahme.",

    expensesTitle: "Ausgaben",
    expensesSubtitle: "Erfasse Ausgaben und behalte die Kosten sauber unter Kontrolle.",
    addExpenseTitle: "Ausgabe hinzufügen",
    addExpenseSubtitle: "Erfasse neue Kosten und ordne sie sauber nach Methode und Kategorie.",
    saveExpense: "Ausgabe speichern",
    savingExpense: "Wird gespeichert...",
    expenseHistory: "Ausgabenverlauf",
    expenseHistorySubtitle: "Sieh dir die letzten Ausgaben mit Methode und Kategorie an.",
    noExpensesYet: "Noch keine Ausgaben vorhanden",
    noExpensesYetSubtitle: "Erfasse die erste Ausgabe und sie wird hier angezeigt.",
    totalExpensesCard: "Gesamtausgaben",
    totalExpensesCardSubtitle: "Alle erfassten Ausgaben",
    cashExpenses: "Barausgaben",
    cashExpensesCard: "Barausgaben",
    cashExpensesSubtitle: "Anzahl der Ausgaben in bar",
    topExpenseCategory: "Top-Kategorie",
    topCategory: "Top-Kategorie",
    topExpenseCategorySubtitle: "Kategorie mit den höchsten Kosten",
    topCategorySubtitle: "Kategorie mit den höchsten Kosten",
    expenseDescriptionPlaceholder: "Z. B. Materialkauf",
    expenseCategoryMaterial: "Material",
    expenseCategoryTransport: "Transport",
    expenseCategorySalary: "Lohn",
    expenseCategoryTools: "Werkzeuge",
    expenseCategoryOther: "Sonstige",
    saveErrorExpense: "Fehler beim Speichern der Ausgabe.",
    materialsHistoryTitle: "Materialverlauf",
    paymentsTitle: "Zahlungen",

    paymentsSubtitle: "Verwalte Zahlungen, Status und Fälligkeiten übersichtlich an einem Ort.",
    addPaymentTitle: "Zahlung hinzufügen",
    addPaymentSubtitle: "Erfasse Zahlungseinträge mit Empfänger, Methode und Status.",
    savePayment: "Zahlung speichern",
    savingPayment: "Wird gespeichert...",
    paymentHistory: "Zahlungsverlauf",
    paymentHistorySubtitle: "Sieh dir die letzten Zahlungen mit Status und Kategorie an.",
    noPaymentsYet: "Noch keine Zahlungen vorhanden",
    noPaymentsYetSubtitle: "Erfasse die erste Zahlung und sie wird hier angezeigt.",
    totalPaymentsCard: "Totale Zahlungen",
    totalPaymentsCardSubtitle: "Alle registrierten Zahlungen",
    pendingPayments: "Ausstehende Zahlungen",
    pendingPaymentsCard: "Ausstehende Zahlungen",
    pendingPaymentsCardSubtitle: "Noch nicht abgeschlossene Zahlungen",
    paidPayments: "Bezahlte Zahlungen",
    paidPaymentsSubtitle: "Anzahl der bereits bezahlten Einträge",
    thisMonthPayments: "Zahlungen diesen Monat",
    thisMonthPaymentsSubtitle: "Monatliche Zahlungsleistung",
    paymentTo: "Empfänger",
    paymentToPlaceholder: "Z. B. Lieferant / Mitarbeiter",
    paymentDescriptionPlaceholder: "Z. B. Monatszahlung",
    paymentStatusPending: "Ausstehend",
    paymentStatusPaid: "Bezahlt",
    paymentCategorySupplier: "Lieferant",
    paymentCategoryWorker: "Mitarbeiter",
    paymentCategoryRent: "Miete",
    paymentCategoryService: "Service",
    paymentCategoryOther: "Sonstige",
    saveErrorPayment: "Fehler beim Speichern der Zahlung.",

    materialsTitle: "Materialien",
    materialsSubtitle: "Verwalte Materialien, Bestand, Lieferanten und Lagerwert an einem Ort.",
    totalMaterialsValue: "Gesamtwert Lager",
    totalMaterialsValueSubtitle: "Geschätzter Gesamtwert aller Materialien",
    inStockMaterials: "Auf Lager",
    inStockMaterialsSubtitle: "Materialien mit normalem Bestand",
    lowStockMaterials: "Wenig Bestand",
    lowStockMaterialsSubtitle: "Materialien, die bald nachbestellt werden sollten",
    orderedMaterials: "Bestellt",
    orderedMaterialsSubtitle: "Materialien, die aktuell bestellt sind",
    addMaterialTitle: "Material hinzufügen",
    addMaterialSubtitle: "Erfasse neue Materialien mit Bestand, Preis und Lieferant.",
    materialName: "Materialname",
    materialNamePlaceholder: "Z. B. Zement",
    supplierPlaceholder: "Z. B. Bau Partner GmbH",
    pricePerUnit: "Preis pro Einheit",
    saveMaterial: "Material speichern",
    savingMaterial: "Wird gespeichert...",
    saveErrorMaterial: "Fehler beim Speichern des Materials.",
    materialsHistory: "Materialübersicht",
    materialsHistorySubtitle: "Sieh dir Materialbestand, Lieferanten und Werte an.",
    noMaterialsYet: "Noch keine Materialien vorhanden",
    noMaterialsYetSubtitle: "Erfasse das erste Material und es wird hier angezeigt.",
    confirmDeleteMaterial: "Möchtest du dieses Material wirklich löschen?",
    materialUnitPieces: "Stk",
    materialUnitKg: "kg",
    materialUnitM2: "m²",
    materialUnitM3: "m³",
    materialUnitBox: "Kiste",
    materialStatusInStock: "Auf Lager",
    materialStatusLowStock: "Wenig Bestand",
    materialStatusOrdered: "Bestellt",

    workersTitle: "Mitarbeiter",
    workersSubtitle: "Verwalte Mitarbeiter, Rollen, Tageslohn und Arbeitsstatus an einem Ort.",
    totalWorkers: "Mitarbeiter gesamt",
    totalWorkersSubtitle: "Gesamtanzahl registrierter Mitarbeiter",
    activeWorkers: "Aktiv",
    activeWorkersSubtitle: "Mitarbeiter, die aktuell aktiv sind",
    vacationWorkers: "Urlaub",
    vacationWorkersSubtitle: "Mitarbeiter im Urlaub oder vorübergehend abwesend",
    inactiveWorkers: "Inaktive Mitarbeiter",
    dailyPayrollEstimate: "Geschätzte Tageskosten",
    dailyPayrollEstimateSubtitle: "Summe aller Tageslöhne",
    addWorkerTitle: "Mitarbeiter hinzufügen",
    addWorkerSubtitle: "Erfasse neue Mitarbeiter mit Rolle, Tageslohn und Status.",
    workerName: "Name des Mitarbeiters",
    workerNamePlaceholder: "Z. B. Arben Krasniqi",
    dailyRate: "Tageslohn",
    saveWorker: "Mitarbeiter speichern",
    savingWorker: "Wird gespeichert...",
    saveErrorWorker: "Fehler beim Speichern des Mitarbeiters.",
    workersHistory: "Mitarbeiterübersicht",
    workersHistorySubtitle: "Sieh dir Rollen, Status und Tageslohn der Mitarbeiter an.",
    noWorkersYet: "Noch keine Mitarbeiter vorhanden",
    noWorkersYetSubtitle: "Erfasse den ersten Mitarbeiter und er wird hier angezeigt.",
    confirmDeleteWorker: "Möchtest du diesen Mitarbeiter wirklich löschen?",
    workerRoleWorker: "Arbeiter",
    workerRoleManager: "Leiter",
    workerRoleDriver: "Fahrer",
    workerRoleElectrician: "Elektriker",
    workerRoleMason: "Maurer",
    workerStatusActive: "Aktiv",
    workerStatusVacation: "Urlaub",
    workerStatusInactive: "Inaktiv",

    reportsTitle: "Berichte",
    reportsSubtitle: "Eine klare Übersicht über Finanzen, Lager und Mitarbeiterleistung.",
    reportIncomeSummary: "Einnahmen",
    reportIncomeSummarySubtitle: "Gesamte erfasste Einnahmen",
    reportExpenseSummary: "Ausgaben",
    reportExpenseSummarySubtitle: "Gesamte erfasste Ausgaben",
    reportPaymentSummary: "Zahlungen",
    reportPaymentSummarySubtitle: "Alle registrierten Zahlungen",
    reportNetBalance: "Netto-Saldo",
    reportNetBalanceSubtitle: "Einnahmen minus Ausgaben und Zahlungen",
    monthlyOverviewTitle: "Monatsübersicht",
    monthlyOverviewSubtitle: "Leistung für den aktuellen Monat",
    reportMonthResultSubtitle: "Monatliches Ergebnis nach Ausgaben und Zahlungen",
    reportAssetsTitle: "Bestand & Team",
    reportAssetsSubtitle: "Wichtige Kennzahlen für Lager und Mitarbeiter",
    reportExpenseBreakdown: "Ausgaben nach Kategorie",
    reportExpenseBreakdownSubtitle: "Hauptkostenbereiche des Unternehmens",
    reportPaymentBreakdown: "Zahlungen nach Kategorie",
    reportPaymentBreakdownSubtitle: "Verteilung der registrierten Zahlungen",
    reportMaterialStatus: "Materialstatus",
    reportMaterialStatusSubtitle: "Überblick über Lagerzustände",
    reportWorkerStatus: "Mitarbeiterstatus",
    reportWorkerStatusSubtitle: "Überblick über die Verfügbarkeit des Teams",

    invoiceReminderTools: "Erinnerungs-Tools",
    invoiceReminderSubtitle: "Sende eine Zahlungserinnerung per Copy, WhatsApp oder E-Mail.",
    invoiceCopyReminder: "Erinnerung kopieren",
    invoicePaymentStatusTitle: "Zahlungsstatus",
    invoicePaidPartial: "Teilweise bezahlt",
    invoicePaidFull: "Vollständig bezahlt",
    invoiceDocumentPreview: "Vorschau der Rechnung",
    invoiceDocumentPreviewSubtitle: "Die Dokumentvorschau zeigt dir das fertige Ergebnis vor dem Drucken",
    invoicePreviewTitle: "Vorschau der Rechnung",
    invoicePreviewSubtitle: "Die Dokumentvorschau zeigt dir das fertige Ergebnis vor dem Drucken",

    invoiceTitle: "Rechnung",
    invoiceSubtitle: "Erstelle professionelle Rechnungen und speichere sie im System.",
    invoiceCreateTitle: "Rechnung erstellen",
    invoiceCreateSubtitle: "Fülle Kundendaten, Positionen und Zahlungsdetails aus.",
    invoiceHistoryTitle: "Rechnungsverlauf",
    invoiceHistorySubtitle: "Die zuletzt gespeicherten Rechnungen.",
    invoiceCustomer: "Kunde",
    invoiceCustomerEmail: "E-Mail",
    invoiceCustomerPhone: "Telefon",
    invoiceCustomerAddress: "Adresse",
    invoiceNumber: "Rechnungsnummer",
    invoiceDate: "Rechnungsdatum",
    invoiceDueDate: "Fälligkeitsdatum",
    invoiceItems: "Positionen",
    invoiceUnitPrice: "Preis / Einheit",
    invoiceLineTotal: "Gesamt",
    invoiceAddItem: "Position hinzufügen",
    invoiceSave: "Rechnung speichern",
    invoiceSaving: "Wird gespeichert...",
    invoicePrint: "Drucken / PDF",
    invoiceRefresh: "Aktualisieren",
    invoiceNoInvoices: "Noch keine Rechnungen vorhanden",
    invoiceNoInvoicesSubtitle: "Erstelle die erste Rechnung und sie wird hier angezeigt.",
    invoiceSaveError: "Fehler beim Speichern der Rechnung.",
    invoiceCompanySection: "Firmendaten",
    invoiceRecipientSection: "Empfängername",
    invoicePaymentInfo: "Zahlungsinformationen",

    backupRestoreTitle: "Backup & Restore",
    backupRestoreSubtitle: "Lokale Sicherung, Wiederherstellung und selektives Zurücksetzen der Datenbank.",
    backupDownloadTitle: "Backup herunterladen",
    backupDownloadText: "Erstellt eine vollständige lokale JSON-Sicherung für PC / Archiv / Migration.",
    backupDownloadBtn: "Backup downloaden",
    backupImportTitle: "Backup laden",
    backupImportText: "Wähle eine bestehende JSON-Datei und prüfe zuerst die enthaltenen Daten.",
    backupChooseFile: "Datei auswählen",
    backupSelectedFile: "Ausgewählte Datei",
    backupPreview: "Vorschau",
    backupNoFile: "Noch keine Datei gewählt.",
    backupCollections: "Sammlungen",
    backupEntries: "Einträge",
    backupReplaceTitle: "Restore Replace",
    backupReplaceText: "Ersetzt die vorhandenen Daten komplett mit dem Inhalt der geladenen Backup-Datei.",
    backupReplaceBtn: "Komplett wiederherstellen",
    backupMergeTitle: "Merge Import",
    backupMergeText: "Importiert die Daten zusätzlich zur vorhandenen Datenbank.",
    backupMergeBtn: "Zusätzlich importieren",
    backupLoaded: "Backup-Datei geladen.",
    backupDownloadOk: "Backup wurde heruntergeladen.",
    backupMergeOk: "Backup wurde erfolgreich importiert.",
    backupReplaceOk: "Backup wurde erfolgreich wiederhergestellt.",
    backupParseFail: "Backup-Datei konnte nicht gelesen werden.",
    backupNoPayload: "Bitte zuerst eine Backup-Datei auswählen.",
    backupReplaceWarning: "Achtung: Replace überschreibt die aktuellen Daten.",

    selectiveResetTitle: "Selektiver Reset",
    selectiveResetText: "Wähle Kategorien aus, die vollständig aus der Datenbank gelöscht werden sollen.",
    selectiveResetBtn: "Ausgewählte Kategorien löschen",
    selectiveResetOk: "Die ausgewählten Kategorien wurden gelöscht.",
    selectiveResetNone: "Bitte wähle mindestens eine Kategorie aus.",
    selectiveResetWarning: "Möchtest du wirklich diese Kategorien löschen?",
    selectAll: "Alle wählen",
    clearSelection: "Auswahl löschen",
    deleting: "Wird gelöscht...",

    backupIncome: "Income",
    backupExpenses: "Expenses",
    backupPayments: "Payments",
    backupMaterials: "Materials",
    backupWorkers: "Workers",
    backupInvoiceClients: "Invoice Clients",
    backupInvoices: "Invoices",
    backupMonthlyStats: "Monthly Stats",
    backupCompanySettings: "Company Settings",

    invoicePrintHint: "Rechnung drucken oder PDF-Dateiname kopieren",
    invoicePdfToolsTitle: "PDF & Druck",
    invoiceCopyPdfName: "PDF-Namen kopieren",
    invoiceSuiteBadge: "BauHeld Rechnungssuite",
    invoiceClientsStat: "Kunden",
    invoiceInvoicesStat: "Rechnungen",
    invoiceTotalAmount: "Rechnungsbetrag",
    invoiceUnpaid: "Unbezahlt",

    settingsTitle: "Einstellungen",
    settingsSubtitle: "Verwalte Firmendaten, Logo, Farben und Rechnungsinformationen an einem Ort.",
    companyProfileTitle: "Firmaprofil",
    companyProfileSubtitle: "Die wichtigsten Informationen über dein Unternehmen.",
    brandingTitle: "Branding",
    brandingSubtitle: "Passe Logo, Farben und visuelle Identität an.",
    billingSettingsTitle: "Fakturierung & Bank",
    billingSettingsSubtitle: "Informationen für Rechnungen und Zahlungen.",
    previewCardTitle: "Vorschau",
    previewCardSubtitle: "So kann deine Firmenkarte im System aussehen.",
    companyNameLabel: "Firmenname",
    ownerNameLabel: "Inhaber / Verantwortliche Person",
    taxNumberLabel: "Steuernummer",
    businessNumberLabel: "Geschäftsnummer",
    emailLabel: "E-Mail",
    websiteLabel: "Webseite",
    addressLabel: "Adresse",
    cityLabel: "Stadt",
    countryLabel: "Land",
    postalCodeLabel: "PLZ",
    logoUrlLabel: "Logo-URL",
    primaryColorLabel: "Primärfarbe",
    secondaryColorLabel: "Sekundärfarbe",
    invoicePrefixLabel: "Rechnungskürzel",
    currencyLabel: "Währung",
    bankNameLabel: "Bankname",
    saveSettings: "Einstellungen speichern",
    savingSettings: "Wird gespeichert...",
    loadErrorSettings: "Einstellungen konnten nicht geladen werden.",
    saveErrorSettings: "Fehler beim Speichern der Einstellungen.",
    saveSuccessSettings: "Einstellungen erfolgreich gespeichert.",
    previewEmptyCompany: "Dein Firmenname erscheint hier",
    logoHint: "Verwende einen direkten Bild-Link für das Firmenlogo.",
    brandHint: "Diese Farben kannst du später auch für PDFs, Rechnungen und Karten nutzen.",
    profileHint: "Die hier gespeicherten Daten können später in Berichten und Rechnungen verwendet werden.",
    lastSavedLabel: "Gespeichert",
    settingsQuickInfo: "Diese Daten werden unter settings/company in Firestore gespeichert.",
    invoiceOverdue: "Überfällig",
    invoiceStatusAuto: "Automatischer Status",

    dashboardOptimizedSubtitle: "Optimiertes Panel",
    dashboardInvoiced: "In Rechnung gestellt",
    dashboardPaidInInvoices: "Bezahlte Rechnungen",
    dashboardOpenInvoices: "Offene Rechnungen",
    dashboardProfit: "Ergebnis",
    dashboardLastInvoices: "Letzte Rechnungen",
    dashboardLastIncome: "Letzte Einnahmen",
    dashboardLastExpenses: "Letzte Ausgaben",
    dashboardCurrentMonthStats: "Statistiken des aktuellen Monats",
    dashboardCurrentMonthStatsSubtitle: "Ein schneller Überblick über die wichtigsten Finanzkennzahlen dieses Monats.",
    dashboardChartsTitle: "Diagramme & Trends",
    dashboardChartsSubtitle: "Monatliche visuelle Übersicht, aufgebaut nur aus Stats-Dokumenten.",
    dashboardOverdueTitle: "Überfällige Rechnungen",
    dashboardOverdueSubtitle: "Sofortige Warnung für Rechnungen, die Nachverfolgung brauchen.",

    dashboardCashFlowTitle: "Cashflow",
    dashboardCashFlowSubtitle: "Monatliche Aufteilung von Einnahmen, Ausgaben und Zahlungen.",
    dashboardInvoicedVsResultTitle: "Rechnungen vs Ergebnis",
    dashboardInvoicedVsResultSubtitle: "Monatlicher Vergleich zwischen Fakturierung und Ergebnis.",
    dashboardIncomeShort: "Einnahmen",
    dashboardExpensesShort: "Ausgaben",
    dashboardPaymentsShort: "Zahlungen",
    dashboardResultShort: "Ergebnis",
    dashboardNoChartData: "Für diesen Zeitraum sind noch keine Diagrammdaten vorhanden.",
    dashboardOnlyRealData: "Nur reale Daten aus Firebase",

    initializeFirestore: "Firestore initialisieren",
    setupSubtitle: "Initiale Datenbank und Grundeinstellungen konfigurieren."
  }
};